<script setup>
import { ref, computed, watch } from 'vue';
import { useRuntimeConfig } from "nuxt/app";
const config = useRuntimeConfig();

const props = defineProps({
  imageClickable: {
    type: Boolean,
    default: true
  },
  user: {
    type: Object,
    default() {
      return {};
    }
  },
  size: {
    type: String,
    default: 'small'
  }
});

const imageOpen = ref(false);
const item = ref(props.user);

const avatarUrls = computed(() => {
  if (item.value?.imageFileName) {
    const baseUrl = config.public.storageBaseUrl;
    return {
      thumbnail: `${baseUrl}/thumbnail_${item.value.imageFileName}`,
      medium: `${baseUrl}/medium_${item.value.imageFileName}`,
      large: `${baseUrl}/large_${item.value.imageFileName}`,
      original: `${baseUrl}/${item.value.imageFileName}`,
    };
  }
  return null;
});

const avatarInitial = computed(() => {
  if (avatarUrls.value !== null) return '';
  return item.value.firstName ? `${item.value.firstName.charAt(0)}${item.value.lastName.charAt(0)}` : '';
});

watch(
    () => props.user,
    (newValue) => {
      item.value = newValue;
    }
);
</script>

<template>
  <v-avatar class="bg-primary text-white font-weight-bold" :size="size === 'small' ? 24 : (size === 'medium' ? 40 : (size === 'large' ? 60 : 120))">
    <v-img
        :class="imageClickable ? 'cursor' : ''"
        @click="() => { if (imageClickable) imageOpen = true; }"
        cover
        v-if="avatarUrls"
        :src="avatarUrls.thumbnail"
    />
    <v-dialog
        :fullscreen="true"
        v-if="avatarUrls && imageClickable"
        :close-on-content-click="true"
        v-model="imageOpen"
        class="pa-5"
    >
      <v-img v-if="avatarUrls" :src="avatarUrls.large" />
    </v-dialog>
    <span
        :style="size === 'small' ? 'font-size: 12px;' : (size === 'medium' ? 'font-size: 18px;' : 'font-size: 30px;')"
        v-else
    >
      {{ avatarInitial }}
    </span>
  </v-avatar>
</template>

<style scoped></style>
